document.addEventListener('click', function (event) {
  var chip = event.target.closest('[data-suroor-chip]');
  if (!chip || chip.disabled) return;

  event.preventDefault();
  event.stopPropagation();

  var cardRoot = chip.closest('.card-wrapper');
  if (!cardRoot) return;

  var variantId = chip.getAttribute('data-variant-id');
  var available = chip.getAttribute('data-available') !== 'false';

  cardRoot.querySelectorAll('[data-suroor-chip]').forEach(function (el) {
    el.classList.toggle('suroor-card-chip--active', el === chip);
  });

  var priceEl = cardRoot.querySelector('.price');
  var template = cardRoot.querySelector('[data-variant-price-template="' + variantId + '"]');
  if (priceEl && template) {
    priceEl.outerHTML = template.innerHTML;
  }

  var hiddenInput = cardRoot.querySelector('.product-variant-id');
  if (hiddenInput) {
    hiddenInput.value = variantId;
    hiddenInput.disabled = !available;
  }

  var addButton = cardRoot.querySelector('.suroor-card-actions__addtocart');
  if (addButton) {
    addButton.disabled = !available;
    var label = addButton.querySelector('span');
    if (label) label.textContent = available ? 'Add to cart' : 'Sold out';
  }

  var quickViewButton = cardRoot.querySelector('.suroor-card-actions__quickview');
  if (quickViewButton) {
    var baseUrl = quickViewButton.getAttribute('data-base-url');
    quickViewButton.setAttribute('data-product-url', baseUrl + '?variant=' + variantId);
  }
});
